import dayjs from 'dayjs'
import { TcClickTypes } from 'src/configuration/tagcommander'
import { colors } from 'src/theme'

import { ActionButtonProps } from '../../components/ActionButton'
import Router from '../../routes/router'
import routes from '../../routes/definitions'
import tcClick from '../tcClick/tcClick'
import { wysiwygTransformer } from '../../utils/DomUtils'

const weekEndDayDetector = (selectedDay: any) => {
  const dayName = dayjs(selectedDay, 'YYYY-MM-DD').format('dddd')

  switch (dayName) {
    case 'lundi':
      return false
    case 'mardi':
      return false
    case 'mercredi':
      return false
    case 'jeudi':
      return false
    case 'vendredi':
      return false
    case 'samedi':
      return true
    case 'dimanche':
      return true
  }
}
const weekTransformer = (
  selectedDay: string,
  selectDayHandler: (date: string) => void,
  startAt?: string,
  resetButtonText?: string,
  tcVars?: { chapter2: string; chapter3: string }
) => {
  const tab = Array(7)
    .fill('')
    .map((_: any, i: number) => {
      const currentDay = dayjs(startAt, 'YYYY-MM-DD').add(i, 'day')
      const textDesktop = currentDay.format('dddd')
      const number = currentDay.format('DD')

      return {
        isLongText: false,
        date: currentDay.format('YYYY-MM-DD'),
        textDesktop,
        textMobile: currentDay.format('ddd'),
        number,
        isActive: selectedDay === currentDay.format('YYYY-MM-DD'),
        onClickFunction: (date: string) => {
          tcClick({
            click_name: `${textDesktop} ${number}_fam`,
            click_type: TcClickTypes.navigation,
            chapter1: 'navigation fam',
            chapter2: tcVars?.chapter2,
            chapter3: tcVars?.chapter3,
          })
          selectDayHandler(date)
        },
      }
    })
  if (resetButtonText) {
    tab.unshift({
      date: '',
      textDesktop: resetButtonText,
      textMobile: resetButtonText,
      number: '',
      isActive: !selectedDay,
      onClickFunction: selectDayHandler,
      isLongText: true,
    })
  }
  return tab
}

export const planningPlannerTransformer = (args: {
  t?: any
  currentRoute?: string
  selectDayHandler?: (date: string) => void
  selectedDay?: string
  startAt?: string
  resetButtonText?: string
  isEarlierPlanning?: boolean
  earlierPlanningId?: string
  tcVars?: { chapter2: string; chapter3: string }
  prompt?: null | (() => void)
  isOffline?: boolean
  onHighlightSelectorDayClick: (value: number) => void
  shouldDisplayHighlightDaySelector?: boolean
  createdAt?: string
  pushInstallAndroid?: {
    shouldDisplay: boolean
    hide: () => void
    onCTACLick: () => void
  }
  pushInstallIOS?: {
    shouldDisplay: boolean
    hide: () => void
  }
  pushInstallAndroidFirefox?: {
    shouldDisplay: boolean
    hide: () => void
  }
  pushNotificationAndroid?: {
    shouldDisplay: boolean
    hide: () => void
    onCTACLick: () => void
  }
  pushMessage?: {
    shouldDisplay: boolean
    hide: () => void
  }
}) => {
  const {
    t,
    currentRoute,
    selectDayHandler,
    selectedDay,
    startAt,
    resetButtonText,
    isEarlierPlanning,
    earlierPlanningId,
    tcVars,
    prompt,
    isOffline,
    onHighlightSelectorDayClick,
    shouldDisplayHighlightDaySelector = true,
    createdAt,
    pushInstallAndroid,
    pushInstallAndroidFirefox,
    pushInstallIOS,
    pushNotificationAndroid,
    pushMessage,
  } = args

  const options = Array.from({ length: 8 }, (_, i) => {
    const currentDay = dayjs(createdAt, 'YYYY-MM-DD').add(i, 'day')
    const textDesktop = currentDay.format('dddd DD/MM')
    return {
      value: i,
      text: textDesktop,
    }
  })

  return {
    ...(shouldDisplayHighlightDaySelector && {
      headerTitle: {
        start: t('planning_planner_title_start'),
        end: t('planning_planner_title_end', {
          endingDate: dayjs(startAt, 'YYYY-MM-DD')
            .add(6, 'day')
            .format('dddd DD/MM'),
        }),
      },
    }),
    ...(!shouldDisplayHighlightDaySelector && {
      title: t('planning_planner_title', {
        startingDate: dayjs(startAt, 'YYYY-MM-DD').format('DD/MM'),
        endingDate: dayjs(startAt, 'YYYY-MM-DD').add(6, 'day').format('DD/MM'),
      }),
    }),
    headerDaySelector: {
      backgroundColor: colors.greenMint,
      color: colors.pureBlack,
      value: options.findIndex(
        (option) =>
          option.text === dayjs(startAt, 'YYYY-MM-DD').format('dddd DD/MM')
      ),
      optionsTitle: t('planning_planner_day_selector_title'),
      options,
      onOptionClick: onHighlightSelectorDayClick,
    },
    selectedDay: selectedDay,
    actionButtons: [
      {
        text: t('planning_planner_preferences'),
        icon: 'settings',
        variantType: 'link',
        disabled: isOffline,
        actionProps: {
          ...Router.getRouteConfig(routes.preferences.name),
          onClickHandler: () => {
            tcClick({
              click_name: `${t('planning_planner_preferences')}_fam`,
              click_type: 'navigation',
              chapter1: 'navigation fam',
              chapter2: tcVars?.chapter2,
              chapter3: tcVars?.chapter3,
            })
          },
          isActive: currentRoute === routes.preferences.path,
        },
      } as ActionButtonProps,
      {
        text: t('planning_planner_my_objectives'),
        icon: 'target',
        variantType: 'link',
        disabled: isOffline,
        actionProps: {
          ...Router.getRouteConfig(routes.objectives.name),
          onClickHandler: () => {
            tcClick({
              click_name: `${t('planning_planner_my_objectives')}_fam`,
              click_type: 'navigation',
              chapter1: 'navigation fam',
              chapter2: tcVars?.chapter2,
              chapter3: tcVars?.chapter3,
            })
          },
          isActive: currentRoute === routes.objectives.path,
        },
      } as ActionButtonProps,
      {
        text: t('planning_planner_hebdo'),
        icon: 'hebdo',
        variantType: 'link',
        actionProps: {
          ...Router.getRouteConfig(routes.hebdo.name),
          onClickHandler: () => {
            tcClick({
              click_name: `${t('planning_planner_hebdo')}_fam`,
              click_type: 'navigation',
              chapter1: 'navigation fam',
              chapter2: tcVars?.chapter2,
              chapter3: tcVars?.chapter3,
            })
          },
          isActive: currentRoute === routes.hebdo.path,
        },
      } as ActionButtonProps,
      {
        text: t('planning_planner_shopping_list'),
        icon: 'cart',
        variantType: 'link',
        earlierPlanningVisible: true,
        offlineVisible: true,
        actionProps: {
          ...(isEarlierPlanning && earlierPlanningId
            ? Router.getRouteConfig(routes.shoppinglistprevious.name, {
              id: earlierPlanningId,
            })
            : Router.getRouteConfig(routes.shoppinglist.name)),
          onClickHandler: () => {
            tcClick({
              click_name: `${t('planning_planner_shopping_list')}_fam`,
              click_type: 'navigation',
              chapter1: 'navigation fam',
              chapter2: tcVars?.chapter2,
              chapter3: tcVars?.chapter3,
            })
          },
          isActive: currentRoute === routes.shoppinglist.path,
        },
      } as ActionButtonProps,
    ].filter(
      (
        item: ActionButtonProps & {
          earlierPlanningVisible?: boolean
          offlineVisible?: boolean
        }
      ) => !isEarlierPlanning || item.earlierPlanningVisible
    ),
    days:
      selectDayHandler &&
      weekTransformer(
        selectedDay ?? '',
        selectDayHandler,
        startAt,
        resetButtonText,
        tcVars
      ),
    isSelectedDayAWeekEndDay: weekEndDayDetector(selectedDay),
    isEarlierPlanning: isEarlierPlanning ? true : false,
    pushInstallAndroid: {
      image: {
        src: '/images/pwa/install.png',
        alt: t('planning_push_install_android_img_alt'),
        width: 130,
        height: 90,
      },
      text: t('planning_push_install_android'),
      cta: {
        text: t('planning_push_install_android_cta_label'),
        onClickHandler: () => {
          if (prompt) {
            prompt()
            pushInstallAndroid?.onCTACLick()
            tcClick({
              click_name: `${t('planning_planner_install')}_fam`,
              click_type: 'navigation',
              chapter1: 'navigation fam',
              chapter2: tcVars?.chapter2,
              chapter3: tcVars?.chapter3,
            })
          }
        },
      },
      onClose: pushInstallAndroid?.hide,
      shouldDisplay: pushInstallAndroid?.shouldDisplay,
    },
    pushInstallAndroidFirefox: {
      image: {
        src: '/images/pwa/install.png',
        alt: t('planning_push_install_ios_img_alt'),
        width: 130,
        height: 90,
      },
      tuto: wysiwygTransformer(t('planning_push_install_android_firefox')),
      onClose: pushInstallAndroidFirefox?.hide,
      shouldDisplay: pushInstallAndroidFirefox?.shouldDisplay,
    },
    pushInstalliOS: {
      image: {
        src: '/images/pwa/install.png',
        alt: t('planning_push_install_ios_img_alt'),
        width: 130,
        height: 90,
      },
      tuto: wysiwygTransformer(t('planning_push_install_ios')),
      onClose: pushInstallIOS?.hide,
      shouldDisplay: pushInstallIOS?.shouldDisplay,
    },
    pushNotification: {
      image: {
        src: '/images/pwa/notification.png',
        alt: t('planning_push_notification_android_img_alt'),
        width: 130,
        height: 90,
      },
      text: t('planning_push_notification_android'),
      cta: {
        text: t('planning_push_notification_android_cta_label'),
        onClickHandler: pushNotificationAndroid?.onCTACLick,
      },
      onClose: pushNotificationAndroid?.hide,
      shouldDisplay: pushNotificationAndroid?.shouldDisplay,
    },
    pushMessage: {
      text: t('planning_express_preference_not_used'),
      onClose: pushMessage?.hide,
      shouldDisplay: pushMessage?.shouldDisplay,
    },
  }
}
